import { get } from 'lodash'

import { SkinDate, Work, getTranslatedString, WorkTitleResource } from '@skinsoft/types'

// Selectors for Work type

export const id = (work: Work) => get(work, 'id')

export const title = (work: Work, locale: string) =>
    getTranslatedString(get(work, 'indexTitle'), locale)

export const workTitles = (work: Work): WorkTitleResource[] | null | undefined => {
    return get(work, 'descriptionMuseumWorkSchema.workTitles')
}

export const workTitle = (work: Work, locale: string): string | null => {
    const titles = workTitles(work)

    if(titles?.length) {
        if(titles[0].title) {
            return getTranslatedString(titles[0].title, locale)
        }
    }

    return null
}

export const creationDates = (work: Work) =>
    get(work, 'descriptionWorkSchema.creationDates', []) || []

export const aliases = (work: Work) =>
    (get(work, 'descriptionWorkSchema.credits', []) || []).map(credit => credit.alias)

export const workType = (work: Work) => get(work, 'identificationWorkSchema.workType')

export const preferredTitle = (work: Work) => {
    const titles = get(work, 'identificationWorkSchema.workTitle', []) || []
    const principalTitle = titles.find(t => t.principal === true)

    return principalTitle ? principalTitle.title || titles[0] : ''
}

export const credits = (work: Work) => {
    const alias = get(
        work,
        'descriptionWorkSchema.credits[0].creatorAuthorDirectors[0].alias',
        null,
    )
    const authorFunction = get(
        work,
        'descriptionWorkSchema.credits[0].creatorAuthorDirectors[0].function[0]',
        null,
    )

    return { alias, authorFunction }
}

export const creationDate = (work: Work) =>
    get(work, 'descriptionWorkSchema.credits[0].creationDates[0].date.skinIntervalComplexes[0].startInterval.dateTxt', null)

export const creationDateSkinDate = (work: Work): SkinDate | undefined | null => {
    return get(work, 'descriptionWorkSchema.credits[0].creationDates[0].date')
}
